var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var MenuListWrapper = function (props) {
    var children = props.children, themeFamily = props.themeFamily;
    return (_jsx(MenuContainer, __assign({ themeFamily: themeFamily, "data-testid": "options-wrapper" }, { children: children }), void 0));
};
export default MenuListWrapper;
var MenuContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: 8px;\n  background-color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: 8px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    return theme.families.search[themeFamily].dark;
});
var templateObject_1;
